
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.Feed.WebApi.Internal
//----------------------------------------------------------


/// <amd-module name="Feed/Common/Contracts/Feed.Internal" />
export interface PackageDependencyDetails {
    group: string;
    normalizedPackageName: string;
    packageId: string;
    packageName: string;
    packageVersionId: string;
    versionRange: string;
}

